// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"e00415e4","156":"e00415e4","652":"920009cf","966":"9d8df9ca"}[chunkId] + ".chunk.css";
};